import Swiper, { Scrollbar, Mousewheel, Lazy, Controller } from "swiper";
Swiper.use([Scrollbar, Mousewheel, Lazy, Controller]);

import swiperClasses from "../util/swiperClasses";

export default class CarouselIntro {
  constructor() {
    this.carousel = "";
  }

  init() {
    this.setupSlider();
  }

  setupSlider() {
    //TODO: refactor with JS classes
    this.carousel = new Swiper(".o-carousel:not(.--hover)", {
      loop: false,
      preventClicksPropagation: false,
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: "auto",
          // spaceBetween: 50,
        },
        // when window width is >= 640px
        1024: {
          slidesPerView: "auto",
          // spaceBetween: 40,
        },
      },
      scrollbar: {
        el: ".o-carousel-scrollbar",
        hide: false,
      },
      ...swiperClasses,
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/components/carouselIntro.js